module.exports = __webpack_public_path__ + "img/cover.1b3f1ea.png";